import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InstagramPostsComponent } from './Components/instagram-posts/instagram-posts.component';


export const instagramRouting: Routes = [
  {
    path: '',
    component: InstagramPostsComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(instagramRouting)],
  exports: [RouterModule],
})
export class InstagramRoutingModule {}
